import styled from "styled-components";
import { styleSheet } from "../../assets/styles/global";

export const Title = styled.h2`
  font-size: 2rem;
  color: ${styleSheet.colorMain};
  margin-bottom: 2rem;
  text-align: left;
`;

export const Input = styled.input`
  width: 200px;
  height: 30px;
  padding: 3px;
  border: 1px solid #000;
  border-radius: 5px;
  text-align: center;
`;

export const OutgoingContainer = styled.div`
  width: 100%;
  margin: 4rem auto;
`;

export const TableColumnText = styled.span`
  font-size: 1.2rem;
  white-space: nowrap;
`;

export const TableDataText = styled.span`
  font-size: 1.1rem;
  white-space: nowrap;
`;

export const ButtonTable = styled.button`
  width: 3.5rem;
  height: 3.5rem;
  border-radius: 1.75rem;
  border: 0;
  margin-right: .5rem;
  /* background: ${({ color }) => color}; */
  background: transparent;
  cursor: pointer;
`;
